import React, { KeyboardEvent, Fragment } from "react"
import { classNames, useWindowDimensions } from "../../utils/helpers"
import Box from "../Box"

// ** 3rd Party Libraries
import { Menu, Transition } from "@headlessui/react"

// ** Icons Import
import { ChevronDownIcon } from "@heroicons/react/20/solid"

interface SelectProps {
  placeholder?: string
  children: any
  id?: string
  onChange?: (val: string) => void
  value?: string
  className?: string
  fullWidth?: boolean
  optionClassName?: string
}

const LegacySelect = (props: SelectProps) => {
  const {
    children,
    onChange,
    value,
    id = "",
    className,
    placeholder = "Select",
  } = props
  const elements = React.Children.toArray(children)

  return (
    <Box
      className={classNames(
        className,
        "relative flex w-full justify-center h-10"
      )}
    >
      <select
        id={id}
        name={id}
        className="block w-full h-12 py-2 pl-3 pr-10 mb-6 text-base border-gray-300 rounded-lg focus:border-blue-500 focus:ring-2 active:border-blue-500 active:ring-2 sm:text-md"
        onChange={(e) => onChange && onChange(e.target.value)}
        defaultValue={value || placeholder}
      >
        <option>{props.placeholder}</option>
        {elements.map((el: any, index: number) => {
          const value = el.props.children

          return (
            <option value={value} key={"select" + index}>
              {" "}
              {el}
            </option>
          )
        })}
      </select>
    </Box>
  )
}

const TailwindDropdown = (props: SelectProps) => {
  const {
    children,
    onChange = () => {},
    value,
    className,
    optionClassName,
    placeholder = "Select",
  } = props
  const elements = React.Children.toArray(children)

  console.log({optionClassName})

  return (
    <Menu
      as="div"
      className={classNames(
        className,
        "relative inline-block text-left w-full"
      )}
    >
      <div>
        <Menu.Button className="inline-flex w-full justify-between rounded-lg border border-gray-300 bg-white px-4 py-[11px] text-base font-medium text-gray-700 shadow-sm hover:bg-gray-50 focus:outline-2 focus:outline-blue-500">
          <div className="max-w-[90%] text-ellipsis whitespace-nowrap overflow-hidden">
            {value || placeholder}
          </div>
          <ChevronDownIcon className="w-5 h-5 ml-2 -mr-1" aria-hidden="true" />
        </Menu.Button>
      </div>

      <Transition
        as={Fragment}
        enter="transition ease-out duration-100"
        enterFrom="transform opacity-0 scale-95"
        enterTo="transform opacity-100 scale-100"
        leave="transition ease-in duration-75"
        leaveFrom="transform opacity-100 scale-100"
        leaveTo="transform opacity-0 scale-95"
      >
        <Menu.Items className="absolute right-0 z-20 w-full mt-2 origin-top-right bg-white rounded-md shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none">
          <div className="py-1">
            {elements.map((el: any, index: number) => {
              const value = el.props.children

              return (
                <Menu.Item key={"select_" + index ? index : Math.random()}>
                  {({ active }) => (
                    <a
                      href="#"
                      className={classNames(
                        active ? `bg-gray-100 text-gray-900 ` : "text-gray-700",
                        "block px-4 py-2 text-sm",
                        optionClassName
                      )}
                      onClick={() => onChange(value)}
                      onKeyDown={(e: KeyboardEvent<HTMLAnchorElement>) => {
                        if (e.keyCode === 32 || e.key === "Enter") {
                          onChange(value)
                        }
                      }}
                    >
                      {el}
                    </a>
                  )}
                </Menu.Item>
              )
            })}
          </div>
        </Menu.Items>
      </Transition>
    </Menu>
  )
}

const CustomSelect = (props: SelectProps) => {
  const { width } = useWindowDimensions()

  if (width && width > 768) {
    // for desktop
    return <TailwindDropdown {...props} />
  } else {
    // for mobile
    return <LegacySelect {...props} />
  }
}

export default CustomSelect
